import { useFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { Button } from "@smart/itops-sb-design-system-dom";
import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";

export const GetArchieButton = () => {
  const { host } = useSmokeballApp();
  const { archieFeature } = useFeatureFlags();
  return (
    archieFeature === "available" && (
      <Button
        text="Get Archie"
        variant="secondaryDefault"
        type="reset"
        className="mx-2 px-[1.15rem] py-[0.3rem] border-orange-400 text-orange-400 hover:border-orange-500 hover:text-orange-500 focus:border-orange-500 focus:text-orange-500 active:border-orange-600 active:text-orange-600"
        onClick={() => host?.selectTab(17)}
      />
    )
  );
};
